import { COMMON_FONT_SIZES, MAX_FONT_SIZE, MIN_FONT_SIZE } from 'constants/fonts';
import { useTranslation } from 'react-i18next';
import { roundToDecimals } from 'utils/number';

import { NumberInputPopover } from '../ToolbarPopover';
import { FontSizeSelectProps } from './FontSizeSelect.types';

/**
 * FONT SIZE SELECT COMPONENT
 *
 * Renders toolbar font size option with
 * - Increment/Decrement buttons
 * - Number input
 * - Dropdown wiith COMMON_FONT_SIZES
 */

const PRECISION = 2;

export const FontSizeSelect = ({
  value,
  onChange,
  onIncrement,
  onDecrement,
  triggerBlurOnUnmount,
}: FontSizeSelectProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'fontSize' });
  const label = t('label');
  const incrementLabel = t('incrementLabel');
  const decrementLabel = t('decrementLabel');

  return (
    <NumberInputPopover
      dropdownOptions={COMMON_FONT_SIZES}
      label={label}
      onChange={onChange}
      onIncrement={onIncrement}
      onDecrement={onDecrement}
      value={roundToDecimals(Number(value), PRECISION) || MIN_FONT_SIZE}
      precision={PRECISION}
      incrementLabel={incrementLabel}
      decrementLabel={decrementLabel}
      min={MIN_FONT_SIZE}
      max={MAX_FONT_SIZE}
      triggerBlurOnUnmount={triggerBlurOnUnmount}
    />
  );
};
